module.exports = __webpack_public_path__ + "img/android.7c0d6a57.svg";